const $ = require('jquery');

module.exports = function () {
    const InfiniteScroll = require('infinite-scroll');

    // global functionality goes here
    window.WPLANG = document.documentElement.lang;
    window.moment.locale(WPLANG.substring(0, 2));

    var body = $('body');
    body.addClass('jsenabled');

    require('./weather.js');
    require('./pikaday.js');

    // sticky top-bar
    var $topbar = $('header[role="masthead"] .top-bar');
    var $topbarWrap = $topbar.closest('.sticky-wrapper');
    var topbarOffset = $topbar.outerHeight();
    var triggerOffset = $(window).height() * 0.1; // scroll distance before top-bar pops out

    $(document).scroll(function () {
        var topoffset = $(document).scrollTop();

        if (topoffset > topbarOffset) {
            if (!$topbar.hasClass('top-bar-scrolled')) {
                $topbarWrap.css('height', topbarOffset);
                $topbar.addClass('top-bar-scrolled');
                setTimeout(function () {
                    $topbar.addClass('scrolled-out');
                }, 1);
            }
        } else {
            if ($topbar.hasClass('top-bar-scrolled')) {
                $topbar.removeClass('top-bar-scrolled scrolled-out');
                $topbarWrap.css('height', 'auto');
            }
        }

        if (topoffset > (topbarOffset + triggerOffset)) {
            if (!$topbar.hasClass('scrolled-in')) {
                $topbar.addClass('scrolled-in');
            }
        } else {
            if ($topbar.hasClass('scrolled-in')) {
                $topbar.removeClass('scrolled-in');
            }
        }
    });


    // initialize lightbox
    $('a.lightbox').nivoLightbox();


    // toggle-menu
    $('#toggle-nav-bar').click(function (e) {
        e.preventDefault();
        if (body.hasClass('show-nav-bar')) {
            body.removeClass('show-nav-bar');
        } else {
            body.addClass('show-nav-bar');
        }
    });
    // close menu
    $('#close-nav-bar').click(function (e) {
        e.preventDefault();
        if (body.hasClass('show-nav-bar')) {
            body.removeClass('show-nav-bar');
        }
    });


    // toggle searchbar
    $('#toggle-search').click(function (e) {
        e.preventDefault();
        $(this).closest('.search').addClass('show-input').find('.search-field').focus();
        $(this).hide();
    });
    $('.search .search-field').blur(function () {
        var $field = $(this);
        setTimeout(function () {
            $field.closest('.search').removeClass('show-input').find('#toggle-search').show();
        }, 2000);
    });


    // insert sub-menu-toggles in primary nav in nav-bar
    $('.nav-bar .nav-primary .menu > .menu-item-has-children').each(function () {
        $(this).append('<span class="sub-menu-toggle">+</span>')
    });

    $('.sub-menu-toggle').click(function () {
        var $parent = $(this).closest('.menu-item-has-children');
        var $submenu = $parent.find('.sub-menu');

        // collapse other shown sub-menu's when new sub-menu is toggled
        $parent.siblings().each(function () {
            if ($(this).hasClass('sub-menu-toggled')) {
                $(this).removeClass('sub-menu-toggled');
                $(this).find('.sub-menu').stop().slideUp(300, 'easeInOutCubic');
                $(this).find('.sub-menu-toggle').html('+');
            }
        });

        // show/hide sub-menu
        if ($parent.hasClass('sub-menu-toggled')) {
            $parent.removeClass('sub-menu-toggled');
            $submenu.stop().slideUp(300, 'easeInOutCubic');
            $(this).html('+');
        } else {
            $parent.addClass('sub-menu-toggled');
            $submenu.stop().slideDown(300, 'easeInOutCubic');
            $(this).html('&minus;');
        }
    });
    $('.events__slider').slick({
        rows: 0,
        arrows: true,
        dots: false,
        prevArrow: '<a href="#" class="slick-control slick-control--prev gtm-event" title="Vorige" data-gtm-event="Events slider control: previous" rel="nofollow"><i class="far fa-angle-left"></i></a>',
        nextArrow: '<a href="#" class="slick-control slick-control--next gtm-event" title="Volgende" data-gtm-event="Events slider control: next" rel="nofollow"><i class="far fa-angle-right"></i></a>',
        slidesToShow: 3,
        slidesToScroll: 1,
        swipeToSlide: true,
        infinite: false,
        speed: 500,
        lazyLoad: 'ondemand',
        adaptiveHeight: true,
        responsive: [
            {
                breakpoint: 1201,
                settings: {
                    slidesToShow: 2
                }
            }, {
                breakpoint: 676,
                settings: {
                    slidesToShow: 1
                }
            }
        ]
    }).on('click', '.slick-slide', function (e) {
        // moving slider when item that is not active is clicked
        if (!$(this).hasClass('slick-active')) {
            e.preventDefault();

            let $slider = $(this).closest('.slick-slider');

            // check if slide is before or after active slides
            if ($(this).prevAll('.slick-active').length) {
                // console.log('element comes after active');
                $slider.slick('slickNext');
            } else {
                // console.log('element comes before active');
                $slider.slick('slickPrev');
            }
        }
    });


    // review slider
    if ($('.review-slider').length) {
        $('.review-slider').slick({
            dots: false,
            arrows: true,
            prevArrow: '<span class="slider-arrow arrow-prev"><i class="fa fa-angle-left"></i></span>',
            nextArrow: '<span class="slider-arrow arrow-next"><i class="fa fa-angle-right"></i></span>',
            infinite: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 250,
            easing: 'easeInOutCubic',
            centerMode: true,
            centerPadding: '10%',
            responsive: [{
                breakpoint: 1400,
                settings: {
                    centerPadding: '5%'
                }
            }, {
                breakpoint: 1200,
                settings: {
                    centerPadding: '50px'
                }
            }, {
                breakpoint: 400,
                settings: {
                    centerMode: false
                }
            }]
        });
    }

    // room slider
    if ($('.room-img-slider').length) {
        $('.room-img-slider .slide-wrapper').slick({
            arrows: true,
            prevArrow: '<span class="slidercontrol slider_prev"><i class="fa fa-angle-left"></i></span>',
            nextArrow: '<span class="slidercontrol slider_next"><i class="fa fa-angle-right"></i></span>',
            dots: false,
            infinite: true,
            autoplay: false,
            speed: 500,
            cssEase: 'ease',
        });
    }

    // expandable items
    $('.expandable-items .item .item__toggle').on('click', function (e) {
        e.preventDefault();

        let $toggle = $(this),
            $item = $toggle.closest('.item'),
            toggledClass = 'item--toggled',
            $content = $toggle.siblings('.item__content');

        if ($item.hasClass(toggledClass)) {
            $item.removeClass(toggledClass);
            $content.stop().slideUp(150, 'easeInOutCubic');
        } else {
            $item.addClass(toggledClass);
            $content.stop().slideDown(150, 'easeInOutCubic');
        }
    });

    // expand pre-toggled expandable items on pageload
    $('.expandable-items .item.item--toggled').each(function () {
        let $content = $(this).find('.item__content');

        $content.stop().slideDown(150, 'easeInOutCubic');
    });

    // input number controls (used in booking form)
    // set disabled classes when value equals min or max value on pageload
    $('.input-number-controls-wrapper .input-number-controls').each(function () {
        var $target = $(this).find('.number-input');
        var startVal = $target.val();
        var min = $target.data('min');
        var max = $target.data('max');

        if (startVal == min) {
            $(this).find('.button-minus').addClass('button-disabled');
        }
        if (startVal == max) {
            $(this).find('.button-plus').addClass('button-disabled');
        }
    });

    // set fake values when input values are bigger than 0
    $('.input-number-controls-wrapper .input-number-controls .number-input.update-fake-input').each(function () {
        var val = $(this).val();
        var targetID = $(this).data('fake-target-id');
        var $target = $('#' + targetID);
        if ($target.length) {
            var updateType = $(this).data('fake-target-update-type');
            var textSingle = $target.data('text-' + updateType + '-single');
            var textMultiple = $target.data('text-' + updateType + '-multiple');
            var $targetCount = $target.find('.' + updateType + '-input .' + updateType + '-count');
            var $targetString = $target.find('.' + updateType + '-input .' + updateType + '-string');

            if (val > 0) {
                $target.find('.' + updateType + '-input').show();
                $targetCount.html(val);
                if (val == 1) {
                    $targetString.html(textSingle);
                } else {
                    $targetString.html(textMultiple);
                }
            } else {
                $target.find('.' + updateType + '-input').hide();
            }
        }
    });

    // button click actions
    $('.input-number-controls-wrapper .input-number-controls .number-control-button').click(function (e) {
        e.preventDefault();
        var $target = $(this).siblings('.number-input');
        var min = $target.data('min');
        var max = $target.data('max');
        var currentVal = $target.val();
        var newVal = currentVal;

        if ($(this).hasClass('button-minus')) {
            if ($(this).siblings('.button-plus').hasClass('button-disabled')) {
                $(this).siblings('.button-plus').removeClass('button-disabled');
            }
            if (currentVal > min) {
                newVal--;
                $target.val(newVal).change();
                if (newVal == min) {
                    $(this).addClass('button-disabled');
                }
            } else {
                var errorText = $(this).data('error-text');
                // alert(errorText);
                if (!$(this).hasClass('button-disabled')) {
                    $(this).addClass('button-disabled');
                }
            }
        } else if ($(this).hasClass('button-plus')) {
            if ($(this).siblings('.button-minus').hasClass('button-disabled')) {
                $(this).siblings('.button-minus').removeClass('button-disabled');
            }
            if (currentVal < max) {
                newVal++;
                $target.val(newVal).change();
                if (newVal == max) {
                    $(this).addClass('button-disabled');
                }
            } else {
                var errorText = $(this).data('error-text');
                // alert(errorText);
                if (!$(this).hasClass('button-disabled')) {
                    $(this).addClass('button-disabled');
                }
            }
        }
    });

    // update fake input
    $('.input-number-controls-wrapper .input-number-controls .number-input.update-fake-input').change(function () {
        var newVal = $(this).val();
        var targetID = $(this).data('fake-target-id');
        var $target = $('#' + targetID);
        if ($target.length) {
            var updateType = $(this).data('fake-target-update-type');
            var textSingle = $target.data('text-' + updateType + '-single');
            var textMultiple = $target.data('text-' + updateType + '-multiple');
            var $targetCount = $target.find('.' + updateType + '-input .' + updateType + '-count');
            var $targetString = $target.find('.' + updateType + '-input .' + updateType + '-string');

            if (newVal > 0) {
                $target.find('.' + updateType + '-input').show();
                $targetCount.html(newVal);
                if (newVal == 1) {
                    $targetString.html(textSingle);
                } else {
                    $targetString.html(textMultiple);
                }
            } else {
                $target.find('.' + updateType + '-input').hide();
            }
        }
    });


    $('.toggle-field-popup').click(function (e) {
        e.preventDefault();

        var $this = $(this);
        var $popup = $this.closest('.field-wrapper.field-has-popup').find('.field-popup');

        var position = this.getBoundingClientRect();
        var spaceBelow = window.innerHeight - position.bottom;
        var spaceAbove = position.top;

        if ($this.hasClass('popup-visible')) {
            $this.removeClass('popup-visible');

            $popup.stop().fadeOut(150, 'easeInOutCubic', () => {
                $popup.removeClass('field-popup--popup-bottom');
                $popup.removeClass('field-popup--popup-top');
            });
        } else {
            // close all other currently open popups
            $('.toggle-field-popup.popup-visible').each(function () {
                $this.removeClass('popup-visible');

                $this.closest('.field-wrapper.field-has-popup').find('.field-popup').stop().fadeOut(150, 'easeInOutCubic', () => {
                    $('.field-popup').removeClass('field-popup--popup-bottom');
                    $('.field-popup').removeClass('field-popup--popup-top');
                });
            });

            $this.addClass('popup-visible');

            if (spaceBelow < $popup.height() && spaceAbove > $popup.height()) {
                $popup.addClass('field-popup--popup-top');
            } else {
                $popup.addClass('field-popup--popup-bottom');
            }

            $popup.stop().fadeIn(150, 'easeInOutCubic');
        }
    });


    // hide certain elements when clicked outside them
    $(document).on('click', function (e) {
        if (!$(e.target).closest('.field-wrapper.field-has-popup').length) {
            $('.toggle-field-popup').each(function () {
                if ($(this).hasClass('popup-visible')) {
                    $(this).removeClass('popup-visible');
                    $(this).closest('.field-wrapper.field-has-popup').find('.field-popup').stop().fadeOut(150, 'easeInOutCubic');
                }
            });
        }
        if (!$(e.target).closest('.nav-bar').length && $(e.target).attr('id') !== 'toggle-nav-bar') {
            if (body.hasClass('show-nav-bar')) {
                body.removeClass('show-nav-bar');
            }
        }
    });


    // animated theme background on hover
    $('.animate-on-hover').hover(function () {
        if ($(this).find('.animated-bg').length) {
            var $animBg = $(this).find('.animated-bg');
            var animImg = $animBg.data('gif-src');
            $animBg.css({
                'background-image': 'url(' + animImg + '?' + Math.random() + ')' // the random number is added to force GIF playing from the start (reloading source) - not ideal for bandwidth with larger GIFs..
            });
        }
    }, function () {
        if ($(this).find('.animated-bg').length) {
            $(this).find('.animated-bg').stop().fadeOut(300, 'easeInOutCubic', function () {
                $(this).css({
                    'background-image': 'none'
                }).show();
            });
        }
    });


    // when a link is clicked with href attribute starting with #, scroll that shit smoothly (if target exists)
    $('a[href^="#"]').click(function (e) {
        e.preventDefault();
        var $anchor = $(this);
        var target = $(this).attr('href');

        if ($(target).length > 0) {
            $('html, body').stop().animate({
                scrollTop: $(target).offset().top - topbarOffset + 1
            }, 1000, 'easeInOutCubic', function () {
                $anchor.blur();
            });
        }
    });


    // pagenav mobile
    if ($('.page-nav-wrapper').length) {
        var $pageNavWrapper = $('.page-nav-wrapper');
        var $pageNavMenu = $pageNavWrapper.find('.page-nav-menu');

        // initialize scrollspy
        $('body').scrollspy({
            target: '.page-nav-wrapper',
            offset: topbarOffset
        });


        function centerActiveItem() {
            var $activeItem = $('.page-nav-wrapper .page-nav-menu li.active');

            if (!$activeItem.length) {
                $activeItem = $('.page-nav-wrapper .page-nav-menu li').first();
            }

            var wrapperWidth = $('.page-nav-wrapper .page-nav').outerWidth();
            var menuWidth = 0;

            $('.page-nav-wrapper .page-nav-menu li').each(function () {
                menuWidth += $(this).outerWidth();
            });


            var prevWidth = 0;

            $activeItem.prevAll().each(function () {
                prevWidth += $(this).outerWidth();
            });

            var menuOffset = (wrapperWidth / 2) - ($activeItem.outerWidth() / 2) - prevWidth - 30;

            // cap menuoffset
            if (menuOffset > 0) {
                menuOffset = 0;
            }

            $('.page-nav-wrapper .page-nav-menu').css({
                'left': menuOffset
            });

        }

        function updatePageNav() {
            var $menu = $('.page-nav-wrapper .page-nav-menu');
            var $itemActive = $menu.find('li.active');
            var $controlPrev = $('.page-nav-wrapper .page-nav-control.control-prev');
            var $controlNext = $('.page-nav-wrapper .page-nav-control.control-next');

            if ($itemActive.index() == 0) {
                $controlPrev.addClass('control-disabled');
            } else {
                $controlPrev.removeClass('control-disabled');
            }

            if ($itemActive.index() == $menu.find('li').length - 1) {
                $controlNext.addClass('control-disabled');
            } else {
                $controlNext.removeClass('control-disabled');
            }

            centerActiveItem();
        }

        $('.page-nav-wrapper').on('activate.bs.scrollspy', function () {
            updatePageNav();
        });

        // behavior for page-nav-controls
        $('.page-nav-wrapper .page-nav-control').click(function (e) {
            e.preventDefault();

            if (!$(this).hasClass('control-disabled')) {
                var $menu = $(this).closest('.page-nav-wrapper').find('.page-nav-menu');
                var $itemActive = $menu.find('li.active');

                if ($(this).hasClass('control-prev')) {
                    // if not first item
                    if ($itemActive.index() !== 0) {
                        $itemActive.prev().find('a').trigger('click');
                    }
                } else if ($(this).hasClass('control-next')) {
                    // if not last item
                    if ($itemActive.index() !== $menu.find('li').length - 1) {
                        $itemActive.next().find('a').trigger('click');
                    }
                }
            }
        });

        updatePageNav();
    }


    // toggle 360 view
    $('#toggle-header-street-view').click(function (e) {
        e.preventDefault();
        $(this).stop().fadeOut(300, 'easeInOutCubic');
    });


    // setting iframe height aspect ratio 16:9 when it contains a youtube video
    $('.contentwrapper iframe').each(function () {
        var $url = $(this).attr('src');
        if ($url.indexOf('youtube.com') >= 0 || $url.indexOf('youtu.be') >= 0) {
            iframeSetAspectRatio($(this));
        }
    });


    // on window resize events
    $(window).on('resize', function () {
        // re-setting iframe height aspect ratio 16:9 when it contains a youtube video
        $('.contentwrapper iframe').each(function () {
            var $url = $(this).attr('src');
            if ($url.indexOf('youtube.com') >= 0 || $url.indexOf('youtu.be') >= 0) {
                iframeSetAspectRatio($(this));
            }
        });

    });


    // load more results
    $('.load-more-results #load-more').click(function (e) {
        e.preventDefault();
        if (!$(this).hasClass('btn-disabled')) {
            $(this).removeClass('btn-default btn-primary').addClass('btn-disabled');
            $('<i/>', {
                'class': 'fa fa-right fa-circle-o-notch fa-spin',
            }).appendTo('.load-more-results #load-more');
        }
    });


    // auto submit form
    $('form.auto-submit').change(function () {
        $('.loader-overlay').stop().fadeIn(150, 'easeInOutCubic');
        this.submit();
    });


    // filter toggles
    $('.filter .toggle-collapse-filter').click(function (e) {
        e.preventDefault();
        var $filter = $(this).closest('.filter');
        if ($filter.hasClass('filter-collapsed')) {
            $filter.removeClass('filter-collapsed').find('.filter-collapsable').slideDown(150, 'easeInOutCubic');
        } else {
            $filter.addClass('filter-collapsed').find('.filter-collapsable').slideUp(150, 'easeInOutCubic');
        }
    });
    // on page-load collapse all filters on mobile, on desktop only collapse filter with class .filter-collapsed
    if ($(window).width() > 991) {
        $('.filter.filter-collapsed').each(function () {
            $(this).find('.filter-collapsable').slideUp(150, 'easeInOutCubic');
        });
    } else {
        $('.filter').each(function () {
            $(this).addClass('filter-collapsed').find('.filter-collapsable').slideUp(150, 'easeInOutCubic');
        });
    }


    //language selector
    $('select[name="lang"]').change(function () {
        window.location.href = $(this).find('option:selected').val();
    });

    // adding readonly attributes to certain GF fields
    if ($('.gform_wrapper li.wc_readonly').length) {
        $('.gform_wrapper li.wc_readonly').each(function () {
            // for inputs
            $(this).find('input').attr('readonly', 'readonly');
            // for textarea
            $(this).find('textarea').attr('readonly', 'readonly');
        });
    }

    $('.content-expandable').each(function () {
        var $container = $(this);

        var $toggles = $container.find('.expand, .collapse');
        $toggles.click(function () {
            $container.toggleClass('expanded')
        });


    });

    if ($('.location-map').length) {
        $maps = $('.location-map').maps({
            scrollwheel: false,
            zoomControl: true,
            mapTypeControl: false,
            scaleControl: false,
            streetViewControl: false,
            rotateControl: false,
            fullscreenControl: false,
            mapTypeId: google.maps.MapTypeId.TERRAIN,
            styles: [{
                stylers: [{
                    saturation: -50
                }]
            }]
        });

        $maps.map.panBy(0, -100);
    }


    if ($('.popover-language-select').length) {
        var selectedLanguage = Cookies.get('lang');

        if (!selectedLanguage) {
            $('#open-lang-popover').trigger('click');
        }
    }

    // social share pop-ups
    function windowPopup(url, width, height) {
        // Calculate the position of the popup so
        // it’s centered on the screen.
        var left = (screen.width / 2) - (width / 2),
            top = (screen.height / 3) - (height / 2);

        window.open(
            url,
            "",
            "menubar=no,toolbar=no,resizable=yes,scrollbars=yes,width=" + width + ",height=" + height + ",top=" + top + ",left=" + left
        );
    }

    // jQuery
    $(".dbk-social-share").on("click", function (e) {
        e.preventDefault();
        windowPopup($(this).attr("href"), 500, 300);
    });

    $('.woocommerce input[name="billing_postcode"]').mask(
        'Z000 SS', {
        placeholder: '1234 AB',
        translation: {
            'Z': {
                pattern: /[1-9]/
            }
        }
    });


    var infScroll = new InfiniteScroll('.scroll-load-container', {
        path: '.next.page-numbers',
        append: '.post-list-item',
        prefill: false,
        history: false,
        hideNav: '.pagination',
        status: '.page-load-status',
    });


    // init tooltips
    $('html').tooltip({
        selector: '[data-toggle="tooltip"]',
        container: 'body'
    });

};
